<template lang="">
  <div v-if="validProject" class="w-full">
    <div class="flex flex-row justify-between m-12 p-3">
      <div class="flex flex-row" style="width: 150px">
        <a @click="back">
          <ArrowCircleLeftIcon
            class="m-1 w-full h-12 rounded-sm label text-button text-xs"
          />
        </a>
      </div>
      <div class="text-3xl">Project Users</div>
      <div class="flex flex-row" style="width: 150px">
        <button
          v-if="$store.state.permissions.addProject"
          @click="displayUserModal = true"
          class="m-1 w-full h-12 rounded-sm bg-button label text-whiteText text-xs"
        >
          Add User
        </button>
      </div>
    </div>
    <div class="justify-center">
      <GoodTable
        :name="'projectusers'"
        :rows="users"
        :columns="columns"
        @removeUser="removeProjectUsers"
      />
    </div>
    <GiveAccessModal
      v-if="displayUserModal"
      :selectedUsers="users"
      :projectId="id"
      :allUsers="allUsers"
      name="projects"
      @updateUsers="updateParent"
      @close="displayUserModal = false"
    />
  </div>
  <div v-else class="w-full">
    <NotFound />
  </div>
</template>
<script>
import Http, { OCR_ENDPOINTS } from "../request";
import GoodTable from "../components/GoodTable.vue";
import GiveAccessModal from "../components/GiveAccessModal.vue";
import NotFound from "../views/404.vue";
import { ArrowCircleLeftIcon } from "@vue-hero-icons/outline";
export default {
  components: {
    GoodTable,
    GiveAccessModal,
    NotFound,
    ArrowCircleLeftIcon,
  },
  data() {
    return {
      displayUserModal: false,
      id: null,
      validProject: true,
      users: [],
      allUsers: [],
      columns: [
        {
          label: "Name",
          field: "name",
        },

        {
          label: "Actions",
          field: "actions",
          sortable: false,
        },
      ],
    };
  },

  created() {
    this.getIDfromURL();
    this.getProjectUsers();
    this.getAllUsers();
  },

  methods: {
    back() {
      this.$router.push("/projects");
    },

    updateParent(newData) {
      this.users = newData;
    },
    getAllUsers() {
      Http()
        .get(OCR_ENDPOINTS.users, {
          params: {
            page: 0,
            size: 1000,
          },
          showLoader: false,
        })
        .then((response) => {
          this.allUsers = response.data;
          // this.formatUsers();
        })
        .finally(() => {});
    },
    getProjectUsers() {
      Http()
        .get(OCR_ENDPOINTS.projects + this.id + "/users", {
          params: {
            page: 0,
            size: 1000,
          },
          showLoader: true,
        })
        .then((response) => {
          this.users = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {});
    },
    addProjectUsers(userId) {
      Http()
        .post(OCR_ENDPOINTS.projects + this.id + "/users", {
          userIdList: userId,
        })
        .then((response) => {
          this.users = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {});
    },
    removeProjectUsers(userId) {
      Http()
        .patch(OCR_ENDPOINTS.projects + this.id + "/users", {
          userIdList: [userId],
        })
        .then((response) => {
          this.users = response.data.users;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {});
    },
    getIDfromURL() {
      this.id = parseInt(window.location.pathname.split("/")[2]);
      Http()
        .get(OCR_ENDPOINTS.projects + `${this.id}`, {
          showLoader: false,
        })
        .then((response) => {
          this.validProject = true;
        })
        .catch((error) => {
          this.validProject = false;
        })
        .finally(() => {});
    },
  },
};
</script>
<style lang=""></style>
